import React, { useState, useEffect } from "react";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";

const UserSelect = ({ selectedUsers, onChange }) => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/users");
        setUsers(data.users);
      } catch (err) { toastError(err); }
    })();
  }, []);

  return (
    <select
      value={selectedUsers}
      onChange={(e) => onChange(e.target.value)}
      className="w-full px-3 py-2 text-sm border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all"
    >
      <option value="">{i18n.t("users.title")} — Todos</option>
      {users.map((user) => (
        <option key={user.id} value={user.id}>{user.name}</option>
      ))}
    </select>
  );
};

export default UserSelect;
